/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-unknown-property */
import React, { FC, ReactElement, useState, useRef, useEffect } from 'react';
import withBrands from '../../hoc/withBrands';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import withLocalization from '../../hoc/withLocalization';
import phoneLogo from '../../../features/siteTheme/Brands/tmvcs/logo/intl-phoneLogo.svg';
import { RootState } from '../../../redux/rootReducer';
import isAsia from '../../../util/isAsia';
import { getSafeTelHref } from '../../../util/CommonLogic';
import './OfferHeader.scss';

interface HeaderProps {
  localize?: any;
  brand?: any;
  localizeImages?: any;
  phone?: any;
  isThankyou?: any;
  chatLink?: any;
}

const OfferHeader: FC<any> = (props: HeaderProps): ReactElement => {
  const { localize, phone, isThankyou, chatLink } = props;
  const prospectDetails: any = useSelector((state: RootState) => state.offerDetails.prospect);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef: any = useRef(null);
  const isMobile = useMediaQuery({ query: `(max-width: 500px)` });
  const phNo = isAsia
    ? localize('preview-sales-engine.static-content.copy.pbeo.intl.asia-default-phone-number')
    : localize('preview-sales-engine.static-content.copy.pbeo.intl.me-default-phone-number');
  const defaultChatLinkText = isAsia
    ? localize('preview-sales-engine.static-content.copy.pbeo.intl.asia-default-chat-link')
    : localize('preview-sales-engine.static-content.copy.pbeo.intl.me-default-chat-link');
  const whatsAppImgData = props.localizeImages('preview-sales-engine.static-content.images.whatsapp-logo', 0, '5:1');
  const whatsAppPath = whatsAppImgData?.path || '';
  const callCenterCode = prospectDetails?.callCenterCode || '';
  const phoneWithDialcode = phone || '';
  const jahiaCallcenter = `preview-sales-engine.static-content.copy.pbeo.intl.call-centers.${callCenterCode}.salesPhone`;
  const callCenterDefault = `${localize(jahiaCallcenter)}`;

  const locPhNo = phoneWithDialcode || callCenterDefault;
  const defaultSalesPhone = locPhNo || phNo;
  const LogoPath = props.localizeImages(
    'preview-sales-engine.static-content.images.marriott-vacation-club-horizontal-sm-logo',
    0,
    '5:1',
  );
  const jahiaKey = `preview-sales-engine.static-content.copy.pbeo.intl.call-centers.${callCenterCode}.chat-link`;

  const chatLinkTextData: any = localize(jahiaKey) || defaultChatLinkText;
  const chatLinkText: any = chatLink ? chatLink : chatLinkTextData;
  const jahiaActivation = `preview-sales-engine.static-content.copy.pbeo.intl.call-centers.${callCenterCode}.activationPhone`;
  const callCenterPhoneWithCode = `${localize(jahiaActivation)}`;
  const defaultActivePhone = localize('preview-sales-engine.static-content.copy.pbeo.default-activation-phone');
  const activationCallcenter = callCenterPhoneWithCode || phNo;
  const phoneDigit = isThankyou ? activationCallcenter : defaultSalesPhone;
  //const sanitizedPhoneDigit = phoneDigit.replace(/[^\d+]/g, '');
  const imageClc = 'img-pinHeader-logo';
  const innerClc = 'innerPinHeaderContainer';
  const topHeadCls = 'topHeaderContainer';

  const handleClickOutside = (e: any) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsOpen(false);
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePhoneClick = () => {
    window.dataLayer.push({
      event: 'phone_call',
    });
    /*const safeHref = getSafeTelHref(phoneDigit);
    if (safeHref.startsWith('tel:')) {
      window.location.href = encodeURI(safeHref);
    } else {
      window.location.href = '#';
    }*/
  };
  const handleOpenList = () => {
    setIsOpen(!isOpen);
  };
  const handleClickChatLink = () => {
    //window.location.href = chatLinkText;
    window.open(chatLinkText, '_blank');
    window.dataLayer.push({
      event: 'whatsapp',
    });
  };
  return (
    <>
      <React.Fragment>
        <>
          <header className={topHeadCls}>
            <div className="header-section-wrapper">
              <div className={innerClc}>
                <div className="img-head-wrapper">
                  {LogoPath?.path && <img src={LogoPath?.path} alt={'brand-logo'} className={imageClc} />}
                </div>
                <div className="phoneHeaderWraper">
                  {isMobile ? (
                    <div className={'mob-listWraper'} ref={dropdownRef}>
                      {/* eslint-disable jsx-a11y/click-events-have-key-events */}
                      <img
                        className="img-phone-logo"
                        arial-label={'see-detail'}
                        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                        role="button"
                        tabIndex={0}
                        onClick={handleOpenList}
                        src={phoneLogo}
                        alt="Call Now"
                      />
                      {isOpen && (
                        <ul className="dropdown-list">
                          <li className={'header-list'}>
                            <a
                              href={encodeURI(getSafeTelHref(phoneDigit))}
                              className="textHeaderLinkMobWraper"
                              onClick={handlePhoneClick}
                            >
                              <img src={phoneLogo} alt="Call Now" />
                              {`+${phoneDigit}`}
                            </a>
                          </li>
                          {chatLinkText && (
                            <>
                              <li className="separator"></li>
                              <li className={'header-list'}>
                                <a href={`#`} onClick={handleClickChatLink}>
                                  <img className="whatsAppHeadLogo" src={whatsAppPath} alt="whatsApp" />
                                </a>
                              </li>
                            </>
                          )}
                        </ul>
                      )}
                    </div>
                  ) : (
                    /*<a className="img-phone-logo" href={`tel:${phoneDigit}`} onClick={handleClick}>
                      <img src={phoneLogo} alt="Call Now" />
                    </a>*/
                    <div className="top-textHeaderWraper">
                      <span className="textHeaderWraper">
                        {localize('preview-sales-engine.static-content.copy.pbeo.have-questions-label')}
                      </span>
                      <a
                        className="textHeaderLinkWraper"
                        href={encodeURI(getSafeTelHref(phoneDigit))}
                        onClick={handlePhoneClick}
                      >
                        {/*<img className='desk-phone-img' src={phoneLogo} alt="Call Now" />*/}
                        {`+${phoneDigit}`}
                      </a>

                      {chatLinkText && (
                        <>
                          <div className="header-pipe">|</div>
                          <a href={'#'} onClick={handleClickChatLink}>
                            <img className="whatsAppHeadLogo" src={whatsAppPath} alt="whatsapp" />
                          </a>
                        </>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </header>
        </>
      </React.Fragment>
    </>
  );
};
export default React.memo(withLocalization(withBrands(OfferHeader)));
